import request from '@/utils/request'

export function groupMasterList(data) {
  return request({
    url: '/mdistributor/group_master',
    method: 'post',
    data
  })
}

export function groupMasterUpdate(id, data) {
  return request({
    url: '/mdistributor/group_master/' + id,
    method: 'post',
    data
  })
}

export function queryChargeRecord(type, data) {
  return request({
    url: '/mdistributor/charge_record/' + type,
    method: 'post',
    data
  })
}

export function getPriceList(type, data) {
  return request({
    url: '/mdistributor/charge_price/' + type,
    method: 'post',
    data
  })
}

export function makeChargeOrder(pid) {
  return request({
    url: '/mdistributor/charge_order/' + pid,
    method: 'post'
  })
}

